import { DecisionContext, DecisionTypeHandler, DbotEventDispatcher } from "../common/commonDomain";
import {
  EmploymentOfManagingDirector,
  EmploymentOfManagingDirectorForm,
} from "./employmentOfManagingDirectorDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: EmploymentOfManagingDirector,
): EmploymentOfManagingDirectorForm {
  return new EmploymentOfManagingDirectorForm(context, data);
}

export function isValid(form: EmploymentOfManagingDirectorForm): boolean {
  return form.isValid;
}

export function validate(form: EmploymentOfManagingDirectorForm): boolean {
  return form.validate();
}

export function applyForm(form: EmploymentOfManagingDirectorForm): EmploymentOfManagingDirector {
  return {
    type: DecisionType.employmentOfManagingDirector,
    newManagingDirector: form.newManagingDirector.validatedValue,
    createManagingDirectorEmploymentAgreement: form.createManagingDirectorEmploymentAgreement.value,
    receivedManagingDirectorEmploymentAgreement:
      form.receivedManagingDirectorEmploymentAgreement.value,
    showManagingDirectorEmploymentAgreementChanges:
      form.showManagingDirectorEmploymentAgreementChanges.value,
    managingDirectorEmploymentAgreementChanges:
      form.managingDirectorEmploymentAgreementChanges.validatedValue,
    giveProcuraManagingDirectorEmploymentAgreementSigning:
      form.giveProcuraManagingDirectorEmploymentAgreementSigning.value,
    newProcuraManagingDirectorEmploymentAgreementSigning:
      form.newProcuraManagingDirectorEmploymentAgreementSigning.value,
    newProcuraManagingDirectorEmploymentAgreementSigningNamedPerson:
      form.newProcuraManagingDirectorEmploymentAgreementSigningNamedPerson.validatedValue,
    procuraManagingDirectorEmploymentAgreementNegotiation:
      form.procuraManagingDirectorEmploymentAgreementNegotiation.value,
    newProcuraManagingDirectorEmploymentAgreementNegotiation:
      form.newProcuraManagingDirectorEmploymentAgreementNegotiation.value,
    newProcuraManagingDirectorEmploymentAgreementNegotiationNamedPerson:
      form.newProcuraManagingDirectorEmploymentAgreementNegotiationNamedPerson.validatedValue,
    giveProcuraManagingDirectorEmploymentAgreementSigningSame:
      form.giveProcuraManagingDirectorEmploymentAgreementSigningSame.value,
  };
}

export const employmentOfManagingDirectorHandler: DecisionTypeHandler<
  DecisionType.employmentOfManagingDirector,
  EmploymentOfManagingDirector,
  EmploymentOfManagingDirectorForm
> = {
  type: DecisionType.employmentOfManagingDirector,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
